export default {
  drawer: localStorage.drawer == "true",
  secondaryDrawer: null,
  color: "success",
  autoopen: localStorage.autoopen == "true",
  image: "https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg"
};
